export default {"src":"https://s91588.cdn.ngenix.net/affiliates-frontend/_next/static/media/credit-card.61f1369a.svg","height":360,"width":462};